import React from 'react'
import { ReferencePopover } from 'components/ReferencePopover'
import { Info } from 'lucide-react'
import { Box } from '@workwhile/ui'
import { ReferenceTable } from 'components/ReferenceTable'

const funnelSteps = [
  {
    key: 'Job listing card viewed',
    description: 'Worker saw this listing in the job feed or browse results',
  },
  {
    key: 'Listing detail viewed',
    description: 'Worker opened the listing detail screen',
  },
  {
    key: 'Shift onboarding started',
    description: 'Worker entered the shift onboarding flow',
  },
  {
    key: 'Tutorial complete',
    description:
      'Worker finished an optional onboarding tutorial, if one was shown',
  },
  {
    key: 'Confirm accept clicked',
    description: 'Worker tapped confirm to accept the shift',
  },
]

const ListingEventsFunnelReferences = () => {
  return (
    <Box
      maxWidth={424}
      color="neutrals.400"
      style={{ maxHeight: '424px', overflowY: 'auto' }}
    >
      <ReferenceTable title="Funnel steps" data={funnelSteps} />
    </Box>
  )
}

export const ListingEventsFunnelReferencePopover = () => {
  return (
    <ReferencePopover
      trigger={<Info size={14} style={{ marginLeft: 4 }} />}
      subTitle="Reference"
      title="Listing user events funnel"
      contentProps={{
        children: <ListingEventsFunnelReferences />,
      }}
    />
  )
}
